import { gql } from '@apollo/client';

export const PRODUCT_EXTERNAL_SEARCH = gql`
  query ProductExternalSearch($query: ProductExternalSearchQueryInput!) {
    productExternalSearch(query: $query) {
      offers {
        id
        ...ProductExternalOfferSummary
      }
    }
  }
`;

export const PRODUCT_EXTERNAL_BY_ID = gql`
  query ProductExternalById($productId: String!) {
    productExternalById(productId: $productId) {
      ...ProductExternalSummary
    }
  }
`;

export const CATALOG_CATEGORY_CHILDREN = gql`
  query CatalogCategoryChildren($type: CatalogTreeRootInput) {
    productCatalogCategoryTreeRoot(type: $type) {
      id
      children {
        ...CatalogCategoryChildrenSummary
        children {
          ...CatalogCategoryChildrenSummary
        }
      }
    }
  }
`;

export const SEOREDIRECT_BY_LOCATOR = gql`
  query SeoRedirectByLocator($url: String!) {
    productCatalogCategoryByLocator(url: $url) {
      id
      seoRedirectPath
    }
  }
`;

export const CATALOG_DEPARTMENT_LINEAGE = gql`
  fragment CoreCatalogCategoryFields on ProductCatalogCategory {
    id
    title
    heroText
    publicUrlPath
    isFeatured
    thumbnail {
      url
    }
    showcase {
      title
      image {
        id
        url
      }
    }
  }

  fragment CoreCatalogCategoryFieldsWithChildren on ProductCatalogCategory {
    ...CoreCatalogCategoryFields

    children {
      ...CoreCatalogCategoryFields

      children {
        ...CoreCatalogCategoryFields

        children {
          ...CoreCatalogCategoryFields
        }
      }
    }
  }

  query ProductCatalogByLocator($url: String!) {
    productCatalogCategoryByLocator(url: $url) {
      ...CoreCatalogCategoryFieldsWithChildren
    }
  }

  query ProductCatalogDepartments($storefront: CatalogStorefront, $types: [CatalogTreeRootInput!]!) {
    productCatalogCategoryTreeRoot(types: $types, storefront: $storefront) {
      ...CoreCatalogCategoryFieldsWithChildren
    }
  }
`;
